import http from '@/utils/services/http'

export default {
  lista (limit, page, filtros) {
    let url = '/api/historico-operacao?page=' + page + '&limit=' + limit + filtros
    return http.get(url)
      .then(response => Promise.resolve(response))
      .catch(({response}) => Promise.reject(response))
  }
}



// WEBPACK FOOTER //
// ./src/domain/historico-alteracoes/services/index.js